const BookingsTableSkeleton = ({ rows = 10 }) => (
  <tbody className="divide-y">
    {Array.from({ length: rows }).map((_, i) => (
      <tr key={i} className="animate-pulse">
        {/* Checkbox */}
        <td className="text-center p-3">
          <div className="w-4 h-4 mx-auto bg-gray-200 rounded" />
        </td>

        {/* Serial # */}
        <td className="p-3 text-center">
          <div className="h-4 w-8 mx-auto bg-gray-200 rounded" />
        </td>

        {/* Customer */}
        <td className="p-3">
          <div className="space-y-2">
            <div className="h-4 w-28 bg-gray-200 rounded" />
            <div className="h-3 w-20 bg-gray-200 rounded" />
          </div>
        </td>

        {/* Services */}
        <td className="p-3">
          <div className="h-4 w-40 bg-gray-200 rounded" />
        </td>

        {/* Amount */}
        <td className="p-3">
          <div className="h-4 w-16 bg-gray-200 rounded" />
        </td>

        {/* Payment Status */}
        <td className="p-3">
          <div className="h-7 w-24 bg-gray-200 rounded-lg" />
        </td>

        {/* Booking Date */}
        <td className="p-3 text-center">
          <div className="space-y-1">
            <div className="h-4 w-16 mx-auto bg-gray-200 rounded" />
            <div className="h-3 w-20 mx-auto bg-gray-200 rounded" />
          </div>
        </td>

        {/* Status */}
        <td className="p-3 pl-8">
          <div className="h-6 w-20 bg-gray-200 rounded-lg" />
        </td>

        {/* Staff */}
        <td className="p-3">
          <div className="h-4 w-24 bg-gray-200 rounded" />
        </td>

        {/* Actions */}
        <td className="py-4 text-center">
          <div className="w-8 h-8 mx-auto bg-gray-200 rounded-lg" />
        </td>
      </tr>
    ))}
  </tbody>
);
export default BookingsTableSkeleton